import { formSubmitClear, formComplete } from 'actions/forms'
import { getPartnerPlanOverviewPages } from 'actions/partnerPlanAdmin'
import { notify } from '../utils/notification'
import { parseError, agent, updateSessionObject } from 'utils/api'
import constants from 'constants'
import { push } from 'react-router-redux'

export const PARTNERPLANADMIN_OVERVIEWPAGE_SAVE_REQUEST = 'PARTNERPLANADMIN_OVERVIEWPAGE_SAVE_REQUEST'
export const PARTNERPLANADMIN_OVERVIEWPAGE_SAVE_ERROR = 'PARTNERPLANADMIN_OVERVIEWPAGE_SAVE_ERROR'
export const PARTNERPLANADMIN_OVERVIEWPAGE_SAVE_COMPLETE = 'PARTNERPLANADMIN_OVERVIEWPAGE_SAVE_COMPLETE'

const saveRequest = () => ({
  type: PARTNERPLANADMIN_OVERVIEWPAGE_SAVE_REQUEST,
})

const saveError = errors => ({
  error: errors[0].error,
  type: PARTNERPLANADMIN_OVERVIEWPAGE_SAVE_ERROR,
})

const saveComplete = result => ({
  result,
  type: PARTNERPLANADMIN_OVERVIEWPAGE_SAVE_COMPLETE,
})

export const editPartnerplanOverviewPage = (payload, formId, redirect = true) => (dispatch) => {
  dispatch(saveRequest())
  agent.PartnerPlanAdmin.updateoverviewpage(payload).then((response) => {
    dispatch(saveComplete(response))
    dispatch(notify('Record saved'))

    if (redirect) {
      dispatch(getPartnerPlanOverviewPages(payload.employee_id))
      // dispatch(push({ pathname: '/beneficiaries' }))
    }
    dispatch(formComplete(formId))
  }).catch((rawError) => {
    const { error, status, description } = parseError(rawError)
    if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
      dispatch(push({
        pathname: '/error',
        search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
      }))
    } else if (status === constants.ERROR.UNAUTHORIZED) {
      updateSessionObject()
    } else {
      dispatch(notify('Error saving partner plan overview page, please try again later', 'warning'))
      // console.warn('Err <editPartnerplanOverviewPage>: ', description, error)
      dispatch(formSubmitClear(formId))
    }
  })
}



// WEBPACK FOOTER //
// ./src/actions/partnerPlanAdminOverviewForm.js